"use client";

import { useTranslations } from "@/app/(site)/europe/useTranslations";
import VadImage from "vadimages-nextjs-image-optimizer";

const logos = [
  {
    imageName: "battery-ce.1.png",
    width: 97,
    height: 82,
  },
  {
    imageName: "battery-fcc.png",
    width: 75,
    height: 62,
  },
  {
    imageName: "battery-roHS.1.png",
    width: 65,
    height: 85,
  },
];

const imageDirectory = "/images/battery-safety-logos/";

export const BatterySafetyLogos = () => (
  <div className="flex gap-10 w-fit mx-auto max-md:px-12">
    {logos.map((c) => (
      <VadImage
        key={`battery-safety-logo-${c.imageName}`}
        src={`${imageDirectory}${c.imageName}`}
        alt={c.imageName}
        width={c.width}
        height={c.height}
      />
    ))}
  </div>
);

export const BatterySafetySection = () => {
  const { batterySafety } = useTranslations();
  return (
    <section className="mt-16 mb-12">
      <p className="text-center font-semibold text-sm tracking-widest uppercase mb-6">
        {batterySafety}
      </p>
      <BatterySafetyLogos />
    </section>
  );
};
